import React from 'react';
import UrlContainer from './components/urlContainer';
import ResaleBreakdown from './components/resaleBreakdown';
import './resale.css';


export default function ResaleMenu({onSubmit = () => {}, config}) {
    const [state, setState] = React.useState({
        'price': config['resale-menu']?.resale_breakdown?.price?.value || null, 
        'is_private_resale': Boolean(config['resale-menu'].is_private_resale)
    });

    return (
        <div className='resale-container'>
            {
                <>
                    {config['resale-menu'].resale_breakdown && (
                        <ResaleBreakdown 
                            data={config['resale-menu']} 
                            state={state} 
                            setState={setState} 
                            mode='resale-menu' 
                            onSubmit={onSubmit} 
                        />
                    )}
                    {config['resale-menu'].resale_option.url && (
                        <UrlContainer 
                            data={config['resale-menu']} 
                            state={state} 
                            onSubmit={onSubmit}
                        />
                    )}
                </>
            }
        </div>
    )
}
